module.exports = __webpack_public_path__ + "media/images/lane/icon_increae-2efb09cb08331258c300a4624089a2fc.svg";